<mat-card class="search-card" data-testid="search-ai-result-card" (click)="onClick()">
    <div fxLayout="row">
        <mat-card-header fxFlex="25">
            <div fxLayout="column" fxFlex="100">
                {{ "SEARCH_AI.UPDATED_ON" | translate }} {{ searchResult().updatedOn | itvDate }}
                <br />
                {{ "SEARCH_AI.MODULE_NAME" | translate }} {{ searchResult().moduleName }}
                <br />
                {{ "SEARCH_AI.DOC_NUMBER" | translate }} {{ searchResult().fullDocNumber }}
                <br />
                {{ "SEARCH_AI.FIELD_NAME" | translate }} {{ searchResult().fieldName }}
            </div>
        </mat-card-header>

        <div fxLayout="column" fxFlex="100">
            <mat-card-content>
                <div fxLayout>
                    <strong fxFlex="75">{{ searchResult().contractNumber }}</strong>
                    <div
                        fxFlex="25"
                        class="cipo--border-radius--xs"
                        [style]="{
                            color: searchResult().stateTextColor,
                            backgroundColor: searchResult().stateColor,
                        }">
                        <div class="cipo--text--center cipo--text--ellipsed">
                            {{ searchResult().stateName | uppercase }}
                        </div>
                    </div>
                </div>
                <span
                    [innerHTML]="
                        searchResult().dataDisplay | truncateText: searchText() | highlight: searchText()
                    "></span>
            </mat-card-content>
        </div>
    </div>
</mat-card>
